import React, { useState } from "react";
import { classList } from "../../utils";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/MenuOpen';
// import { Link } from "gatsby"
const ListLink = props => (
  <li style={{ display: `inline-block`, marginRight: `1rem` }}>
    {/* <Link to={props.to}>{props.children}</Link> */}
    {props.children}
  </li>
)
const TopBar6 = (props) => {
  const [isClosed, setIsClosed] = useState(true);

  return (
    <section
      className={classList({
        header: true,
        // "header-fixed": !isTop,
        closed: isClosed,
      })}
    >
      <div className="container header-container">
        <div className="brand">
          <img src="./assets/images/move-design/logo.png" alt="" />
        </div>
        <ul className="navigation">
          <li>
            <ListLink to="/">
              Home
            </ListLink>
          </li>
          <li>
            <ListLink to="/about">
              About
            </ListLink>
          </li>
        </ul>
        <div className="m-auto" />
        {/* <div className="navigation flex">
            <Button
              className="box-shadow-none px-8 rounded-l hover-bg-primary capitalize"
              variant="outlined"
              color="primary"
            >
              Login
            </Button>
            <Button
              className="box-shadow-none px-8 rounded-r hover-bg-primary capitalize"
              variant="outlined"
              color="primary"
            >
              Signup
            </Button>
        </div> */}
        <IconButton
          className="header__toggle"
          onClick={() => {
            setIsClosed(!isClosed);
          }}
        >
          <MenuIcon/>
        </IconButton>
      </div>
    </section>
  );
};

export default TopBar6;
